import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";
import { Provider } from "react-redux";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyDyUZGG5uSoMaifYVEGFocDNZBk2GEWSG0",
  authDomain: "urvans-cf980.firebaseapp.com",
  databaseURL: "https://urvans-cf980.firebaseio.com",
  projectId: "urvans-cf980",
  storageBucket: "urvans-cf980.appspot.com",
  messagingSenderId: "440361755867",
  appId: "1:440361755867:web:e7af4020ea9294d03f18fe",
  measurementId: "G-M06DZCLRNR",
};
firebase.initializeApp(firebaseConfig);
firebase.firestore();

ReactDOM.render(
  <Provider store={store}>
      <App />
  </Provider>
, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
